import ScrollTo from './scroll-to';

export default { ScrollTo };
